import React from 'react';

export default function IconMenuProfile() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 9.875H6.08333C4.79417 9.875 3.75 10.9192 3.75 12.2083V13.375C3.75 14.0167 4.275 14.5417 4.91667 14.5417H13.0833C13.725 14.5417 14.25 14.0167 14.25 13.375V12.2083C14.25 10.9192 13.2058 9.875 11.9167 9.875H9Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 8.12501C10.2887 8.12501 11.3333 7.08034 11.3333 5.79168C11.3333 4.50301 10.2887 3.45834 9 3.45834C7.71133 3.45834 6.66666 4.50301 6.66666 5.79168C6.66666 7.08034 7.71133 8.12501 9 8.12501Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
